<template>
  <div class="d-flex flex-column page-wrapper identity-verification">
    <page-header>
      <span v-if="isJointApplication == false"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.identityVerification") }}</span>
      <span v-if="isJointApplication == true"><span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.primaryApplicantIdentityVerification" )}}</span>
    </page-header>
    <div class="container d-flex flex-column align-items-center page-container">
      <div class="d-flex flex-row justify-content-around steps-container">
        <!-- TODO update step dots -->
        <div class="dot previous-dot"></div><!-- Identification -->
        <div class="dot previous-dot"></div><!-- Contact Info -->
        <div class="dot current-dot"></div><!-- Other Info -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Identification -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Contact Info -->
        <div class="dot next-dot" v-if="isJointApplication == true"/><!-- Joint Other Info -->
        <div class="dot next-dot"></div><!-- Accounts -->
        <div class="dot next-dot"></div><!-- Funding -->
        <div class="dot next-dot"></div><!-- Review -->
      </div>
      <!-- <p class="explanation-text">
        Thanks for all that information, we know it's a lot to go through. 
        A big part of our commitment to our members is protecting their identity. 
        Based on the information you entered, we have some quick questions we'd like you to verify for the primary applicant.
      </p> -->
      <div class="d-flex flex-column justify-content-start align-items-start form-container" style="padding-top:10px">
        <b-form @submit.prevent="submit" novalidate>
            <div v-if="!mfaLinkSent && !passCodeSent && !personVerified && !processing">
                <label class="form-label">Mobile Phone Number</label>
                <p class="explanation-txt">We have teamed up with Equifax to verify and protect your identity. This will also help us fill out your application.</p>
                <p>Enter your mobile phone number and we'll text you a link to get started!</p>          
                <b-form-input type="tel" v-model="phoneNumber" v-mask="'(###)###-####'" class="text-center d-flex flex-row" />
                <br />
                <b-button class="btn btn-width" variant="secondary" @click="sendMfaLinkAsync" @keyup.enter="sendMfaLinkAsync">Send Link</b-button>          
                <br />          
                <p>It's OK if you don't have a smart phone. We can send you a One-Time Passcode instead.</p>
                <b-button class="btn btn-width" variant="secondary" @click="sendPasscodeAsync" @keyup.enter="sendMfaLinkAsync">Send One-Time Passcode</b-button>
            </div>


            <div v-if="isMobileAuth && !mobileAuthSent && !isPassCodeAuth && !isVerifiedPerson">
                <label class="form-label">Mobile Phone Number</label>
                <p class="explanation-txt">We have teamed up with Equifax to verify and protect your identity. This will also help us fill out your application.</p>
                <p>Enter your mobile phone number and we'll text you a link to get started!</p>          
                <b-form-input type="tel" v-model="phoneNumber" v-mask="'(###)###-####'" class="text-center d-flex flex-row" />
                <br />
                <b-button class="btn btn-width" variant="secondary" @click="sendMfaLinkAsync" @keyup.enter="sendMfaLinkAsync">Send Link</b-button>          
                <br />          
                <p>It's OK if you don't have a smart phone. We can send you a One-Time Passcode instead.</p>
                <b-button class="btn btn-width" variant="secondary" @click="sendPasscodeAsync" @keyup.enter="sendMfaLinkAsync">Send One-Time Passcode</b-button>
            </div>
            <b-form-group class="form-label" v-if="!isMobileAuth && mobileAuthSent && !isPassCodeAuth && !isVerifiedPerson">
              <div class="container d-flex flex-column align-items-center" v-if="!mobileAuthDone">
                <p><strong>A verification link is being sent to your device, once you have verified your mobile device with this link, you will be able to Continue</strong></p>
                <img src="@/assets/img/light/activity.gif" class="processing-img">
              </div>          
              <div v-if="mobileAuthDone">
                <p>Great we were able to verify your device! If you want, we can prefill some of your data to fill out this application. In order to do so, we will also need to send you a One-Time Passcode too. Click below if you want to send the passcode now.</p> 
                <b-button variant="secondary" class="btn btn-width" :ok-only="true" @click="sendPasscodeAsync()">Send Passcode</b-button>
                <br />
                <br />
                <p>It's OK if you don't want to complete the prefill process. You can provide your information yourself instead.</p> 
                <b-button variant="secondary" class="btn btn-width" :ok-only="true" @click="declinePrefill()">Continue</b-button>
              </div>
            </b-form-group>
            <b-form-group class="form-label" label="Passcode" v-if="!isMobileAuth && !mobileAuthSent && isPassCodeAuth && !isVerifiedPerson">
              <p class="explanation-txt">Once you receive your One-Time Passcode, enter it here.</p>
              <b-form-input type="text" class="text-center d-flex flex-row" v-model="passCode" />
              <br />
              <b-button variant="secondary" class="btn btn-width" @click="verifyPasscodeAsync">Confirm Passcode</b-button>
              <br />
              <br />
              <b-button variant="primary" class="btn btn-width" @click="sendPasscodeAsync">Resend Passcode</b-button>
              <div style="font-size: small">*If you didn't receive a passcode, we can try to re-send it up to 3 times.</div>
            </b-form-group>
            <b-form-group class="form-label" v-if="!isMobileAuth && !mobileAuthSent && !isPassCodeAuth && isVerifiedPerson && !loading">
              <p>Great! We were able to verify your passcode! <span v-if="mobileAuthDone">If you want, we can prefill some of your data to fill out this application.</span></p>
              <p v-if="mobileAuthDone">If you wish to prefill your data, all we need is the Zip Code listed on your State or Government Issues Identification or Driver's License and the last 4 digits of your Social Security number.</p>            
              <p v-if="!mobileAuthDone">The last thing we need is the Zip Code listed on your State or Government Issues Identification or Driver's License and the last 4 digits of your Social Security number.</p>            
              <label class="form-label">Zip Code</label>
              <b-form-input class="text-center d-flex flex-row" v-model="zipCode"  v-mask="'#####', '#####-####'"/>
              <label class="form-label">Last 4 of your Social Security number</label>            
              <b-form-input class="text-center d-flex flex-row" v-model="taxId" type="password" maxlength="4" />
              <br />
              <p class="explanation-txt">By clicking I Agree, you authorize your wireless carrier to disclose your mobile number to our third party service providers to verify your identity and prevent fraud. Additionally, you authorize Atomic and its service providers to obtain your name, address, email and Social Security Number from Equifax in order to validate your identity and/or populate this form.</p>             
              <p class="explanation-txt">If you do not wish to authorize this, you can click I Decline and provide your information.</p>                        
              <b-button variant="secondary" class="btn btn-width" @click="getPrefillData">I Agree</b-button>              
              <br />
              <br />
              <b-button variant="secondary" class="btn btn-width" @click="declinePrefill">I Decline</b-button>              
            </b-form-group>
        </b-form>
      </div>
      <div class="d-flex flex-column align-items-center align-content-center justify-content-center form-container" v-if="loading">
        <p class="processing-text">{{ loadingText }}</p>
        <img src="@/assets/img/light/activity.gif" class="processing-img" />                           
      </div>
    </div>
    <page-footer />
    <b-modal ref="errorModalRef" body-text-variant="dark" header-text-variant="dark" centered ok-only ok-variant="secondary" title="Error">{{ errorText }}</b-modal>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Verification",
  components: {
  },
  directives: {
    mask
  },
  props: {
  },
  created() {
  },
  mounted() {
    this.phoneNumber = null;
  },
  data() {
    return {
        pageContent: [],
        loading: false,
        loadingText: '',
        isMobileAuth: true,
        isPassCodeAuth: false,
        isVerifiedPerson: false,
        mobileAuthSent: false,
        mobileAuthDone: false,

        processing: false,
        processingText: '',
        errorText: '',
        passCodeSent: false,
        mfaLinkSent: false,
        personVerified: false,
    };
  },
  computed: {
    ...mapState([
      'currentState',
      'editMode',
      'creditUnion',
      'isJointApplication',
      'identityVerification',
    ]),
    ...mapGetters([
      'getPageContent',
    ]),
    creditUnionName: {
      get() {
        return this.creditUnion.name;
      }
    },
    phoneNumber: {
      get() {
        return this.identityVerification.phoneNumber;
      },
      set(value) {
        this.updateIdvPhone(value);
      }
    },
    passCode: {
        get() {
            return this.identityVerification.passcode;
        },
        set(value) {
            this.updateIdvPasscode(value);
        }
    },
    zipCode: {
        get() {
            return this.identityVerification.zipCode;
        },
        set(value) {
            this.updateIdvZip(value);
        }
    },
    taxId: {
        get() {
            return this.identityVerification.tin;
        },
        set(value) {
            this.updateIdvTaxId(value);
        }
    }
  },
  methods: {
    ...mapMutations([
      'updateIdvPhone',
      'updateIdvPasscode',  
      'updateIdvZip', 
      'updateIdvTaxId',
      'updateIdvSessionId',
      'updateIdvToken',
      'updateIdvTransactionKey',
    ]),
    ...mapActions([
      'sendMfaLink',
      'sendPasscode',
      'verifyMfaLink',
      'verifyPasscode',
      'getVerifiedPerson',
      'updatePrimaryPerson'
    ]),
    async sendMfaLinkAsync(){   
      if(this.phoneNumber) { 
        this.processing = true;
        this.loadingText = 'We are sending the secure link to your device, please wait...';
        let response = await this.sendMfaLink(this.identityVerification);
        if(response.success) {
          this.mfaLinkSent = true;
          this.updateIdvSessionId(response.sessionId);
          this.updateIdvToken(response.token);
          this.processing = false;
        } else {
          this.errorText = 'We are sorry, we could not send a secure link to your device';
          this.processing = false;
          this.$refs.errorModalRef.show();
        }
      } else {
        this.errorText = 'Please provide a valid phone number to send the secure link';
        this.$refs.errorModalRef.show();
      }
    },
    async sendPasscodeAsync() {        
      if(this.phoneNumber) {
        this.loading = true;
        this.loadingText = 'We are sending the One-Time Passcode to your phone, please wait...';
        this.isMobileAuth = false;          
        this.mobileAuthSent = false;
        this.isPassCodeAuth = false;
        let response = await this.sendPasscode(this.identityVerification);
        if(response.success) {
          this.loading = false;
          this.isPassCodeAuth = true;            
          this.updateIdvSessionId(response.sessionId);
          this.updateIdvToken(response.token);
          this.updateIdvTransactionKey(response.transactionKey);
        } else {            
          this.errorText = 'We are sorry, we could not send the One-Time Passcode to your device';
          this.isMobileAuth = true;
          this.loading = false;
          this.$refs.errorModalRef.show();
        }
      } else {
        this.errorText = 'Please provide a valid phone number to send the One-Time Passcode';
        this.isMobileAuth = true;
        this.loading = false;
        this.$refs.errorModalRef.show();
      }
    },
    async verifyMfaLinkAsync() {
      this.loading = true;
      this.loadingText = 'We are verifying the link from your device, please wait...';
      console.info('starting verify mfa link');
      let response = await this.verifyMfaLink(this.identityVerification);
      if(response.success) {
        this.loading = false;
        this.mobileAuthSent = false;
        this.isVerifiedPerson = true;
      } else {
        this.errorText = 'We are sorry, we could not verify that you have clicked the secure link on your device';
        this.$refs.errorModalRef.show();
      }
    },
    async verifyPasscodeAsync(){
      if(this.passCode) {
        this.loading = true;
        this.loadingText = 'We are verifying your One-Time Passcode, please wait...';
        console.info('verifying passcode')
        this.isPassCodeAuth = false
        let response = await this.verifyPasscode(this.identityVerification);
        if(response.success) {
          this.loading = false;
          this.isVerifiedPerson = true;          
        } else {
          this.loading = false;
          this.errorText = 'We are sorry, we could not verify your passcode';
          this.isPassCodeAuth = true;
        this.$refs.errorModalRef.show();
        }
      } else {
        this.errorText = 'Please enter your your passcode to validate';
        this.$refs.errorModalRef.show();
      }
    },
    async getPrefillData() {
      if(this.zipCode && this.taxId) {
        this.loading = true;
        this.loadingText = 'Please wait while we verify your information';
        let response = await this.getVerifiedPerson(this.identityVerification);
        if(response.success) {            
          await this.updatePrimaryPerson({ person: response.person });       
          this.$router.push("identification");
        } else {
          this.loading = false;
          this.errorText = 'We are sorry, we could not verify your information';
          this.$refs.errorModalRef.show();
        }
      } else {
        this.errorText = 'Please provide your Zip Code and last 4 of your Social Security number to proceed';
        this.$refs.errorModalRef.show();
      }
    },
    declinePrefill: function() {        
      this.$router.push("identification");
    },
  },
};
</script>